import { toNumber } from '@amcharts/amcharts4/.internal/core/utils/Type';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import {
  Personal,
  Process
} from 'src/app/performance-dashboard/model/performance.model';
import { PerformanceService } from 'src/app/performance-dashboard/services/performance.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { Router } from '@angular/router';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-leader-board',
  templateUrl: './leader-board.component.html',
  styleUrls: ['./leader-board.component.css'],
})
export class LeaderBoardComponent implements OnInit, OnChanges {
  @Input() personalProcessData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  personalData: Personal[] = [];
  processData: Process[] = [];
  LeaderCommon: Personal[] = [];
  clonedCommon: { [s: string]: Personal } = {};
  clonedPersonal: { [s: string]: Personal } = {};
  clonedProcess: { [s: string]: Process } = {};
  LeaderData : any;
  DisableExport : boolean = false;

  constructor(
    private PDService: PerformanceService,
    private baseService: BaseService,
    private router: Router
  ) { }

  ngOnInit() { }

  ngOnChanges(): void {
    if (
      this.personalProcessData &&
      this.personalProcessData.personalData &&
      this.personalProcessData.processData
    ) {
      this.LeaderCommon = this.personalProcessData.personalData.filter(x => x.id <= 3);
      this.personalData = this.personalProcessData.personalData.filter(x => x.id > 3);
      this.processData = this.personalProcessData.processData;
    }
  }

  onRowEditInit(data: any, type: string) {
    switch (type) {
      case 'Common':
        this.clonedCommon[data.id] = { ...data };
        break;
      case 'Personal':
        this.clonedPersonal[data.id] = { ...data };
        break;
      case 'Process':
        this.clonedProcess[data.id] = { ...data };
        break;
    }
    this.DisableExport = true;
  }

  onRowEditSave(data: any, index: number, type: string) {
    if (data.id > 0) {
      switch (type) {
        case 'Common':
          delete this.clonedCommon[data.id];
          this.LeaderCommon[index].YTD = data.Jan + data.Feb + data.Mar + data.Apr + data.May + data.Jun + data.Jul + data.Aug + data.Sep + data.Oct + data.Nov + data.Dec;
          break;
        case 'Personal':
          delete this.clonedPersonal[data.id];
          this.personalData[index].YTD = data.Jan + data.Feb + data.Mar + data.Apr + data.May + data.Jun + data.Jul + data.Aug + data.Sep + data.Oct + data.Nov + data.Dec;
          break;
        case 'Process':
          delete this.clonedProcess[data.id];
          this.processData[index].YTD = data.Jan + data.Feb + data.Mar + data.Apr + data.May + data.Jun + data.Jul + data.Aug + data.Sep + data.Oct + data.Nov + data.Dec;
          break;
      }
    }
    this.DisableExport = (Object.keys(this.clonedCommon).length + Object.keys(this.clonedPersonal).length + Object.keys(this.clonedProcess).length) > 0 ? true : false;
  }

  onRowEditCancel(personal: any, index: number, type: string) {
    switch (type) {
      case 'Common':
        this.LeaderCommon[index] = this.clonedCommon[personal.id];
        delete this.clonedCommon[personal.id];
        break;
      case 'Personal':
        this.personalData[index] = this.clonedPersonal[personal.id];
        delete this.clonedPersonal[personal.id];
        break;
      case 'Process':
        this.processData[index] = this.clonedProcess[personal.id];
        delete this.clonedProcess[personal.id];
        break;
    }
    this.DisableExport = (Object.keys(this.clonedCommon).length + Object.keys(this.clonedPersonal).length + Object.keys(this.clonedProcess).length) > 0 ? true : false;
  }

  GetLeaderBoardSelectedDetails(UnitId,Unit,Column,sequence){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":sequence === 1 ? "Leaderboard-PS" : "Leaderboard-Process" ,
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetLeaderBoardSelectedDetails.bind(this));
  }
  callbackMethodForGetLeaderBoardSelectedDetails(response){
    if(response.Success)
    this.LeaderData = response.Result;
  }

  Redirect(value,UnitId)
  {
  //this.router.navigate(['/incident/report-incident/'+value])
  window.open(ConstantsService.URL.APP + ['/incident/report-incident/'+value], '_self');
  }
  Redirect1(value,UnitId)
  {
  //this.router.navigate(['/observation/make-observation/', value, { unitId:UnitId }])
  window.open(ConstantsService.URL.APP + ['/observation/make-observation/'+value+';unitId='+UnitId], '_self');
  }
  Redirect2(value,processId)
  {
  //this.router.navigate(['/actiontracker/all-action-details', value, { processId:processId }])
  window.open(ConstantsService.URL.APP + ['/actiontracker/all-action-details/'+value+';processId='+processId], '_self');
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('LeadershipCommonTableToExport');
  const ws1: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws1['!ref'] = ws1['!ref'].replace('O','N');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws1, 'Leadership Common');

  let element1 = document.getElementById('PersonalSafetyTableToExport');
  const ws2: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element1);
  ws2['!ref'] = ws2['!ref'].replace('O','N');//to remove Actions Column
  XLSX.utils.book_append_sheet(wb, ws2, 'Personal Safety');

  let element2 = document.getElementById('ProcessSafetyTableToExport');
  const ws3: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element2);
  ws3['!ref'] = ws3['!ref'].replace('O','N');//to remove Actions Column
  XLSX.utils.book_append_sheet(wb, ws3, 'Process Safety');

  /* save to file */  
  XLSX.writeFile(wb, "LeaderBoardDashboard.xlsx");

  }
  //EOC Pritesh

}
